import Basic from "components/recoveries/area-measures/controls/basic"
import Detailed from "components/recoveries/area-measures/controls/detailed"
import Percent from "components/recoveries/area-measures/controls/percent"
import DeleteConfirmation from "components/modal/delete-confirmation"
import LeaseType from "components/recoveries/area-measures/controls/lease-type"
import TenantGroup from "components/recoveries/area-measures/controls/tenant-group"

export default {
  Basic,
  Detailed,
  LeaseType,
  Percent,
  DeleteConfirmation,
  TenantGroup
}
